import { v4 as uuidv4 } from "uuid";

import { AccessType } from "entities/Package/constants";

export const getInitialInvitation = () => ({
  id: uuidv4(),
  email: "",
  access_type: Object.values(AccessType)[0],
});
